import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useSmoothScroll } from '@/components/site/Motion';
import ChatWidget, { ChatProvider } from '@/components/site/ChatWidget';

export default function Layout() {
  useSmoothScroll();
  return (
    <ChatProvider>
      <div className="min-h-screen flex flex-col bg-brand-bone" data-testid="site-layout">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <ChatWidget />
      </div>
    </ChatProvider>
  );
}
